import { forwardRef } from 'react';
import styled from 'styled-components';
import { __ } from '../locales';
import images from '../images';
import checkIcon from '../images/Check.png';

const Container = styled.button`
  min-width: 300px;
  min-height: 82px;
  background-color: white;
  padding: 18px 15px;
  margin-right: 12px;
  box-shadow: 0 1px 6px 3px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  border-radius: 3px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  list-style-type: 'none';
  &.disabled {
    background-color: ${process.env.REACT_APP_COLOR_RC_BODY_BG};
    * {
      color: #bfbfbf !important;
    }
  }
`;

const Title = styled.h3`
  max-width: 100%;
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-align: center;
`;

const CategoryLabel = styled.p`
  margin-top: 2px;
  max-height: 25px;
  text-align: center;
`;

const ContentContainer = styled.div`
  flex:1;
    overflow: hidden;
`;

const Action = styled.div`
  background-color: transparent;
  width: 30px;
  height: 30px;
  min-width: 30px;
  min-height: 30px;
  max-width: 30px;
  max-height: 30px;
  align-self: center;
  margin-right: 5px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  &.ready {
    background-image: url(${images.play});
  }
  &.done {
    background-image: url(${images.done});
  }
  &.locked {
    background-image: url(${images.black_lock});
  }
  &.royal-locked {
    background-image: url(${images.royal_lock});
  }
`;

const CheckIcon = styled.img`
  width: 40px;
  height: 40px;
  background-image: url(${images.check});
`;

const Lesson = forwardRef(({
  title,
  description,
  onClick,
  disabled,
  status,
  data
}, ref) => (
  <Container
    ref={ref}
    className={disabled ? 'disabled' : ''}
    onClick={() => {
      if (
        onClick
        && !disabled
      ) onClick(data);
    }}
  >
    <ContentContainer>
      {
        status
          && status.includes('locked')
          ? (
            <Title style={{ color: process.env.REACT_APP_COLOR_RC_ROYAL }}>
              {__('app.unlock_with_completion_of_rf')}
            </Title>
          ) : null
      }
      {
        status !== 'royal-locked'
          ? (
            <Title>{title}</Title>
          )
          : null
      }
      {
        description
          && status !== 'royal-locked'
          ? (
            <CategoryLabel>
              {description}
            </CategoryLabel>
          ) : null
      }
    </ContentContainer>
    {status === 'done' ? <CheckIcon alt="Check" src={checkIcon} /> : <Action role="img" alt={status} className={status} />}
  </Container>
));

export default Lesson;
